import { createFileRoute } from "@tanstack/react-router";
import { footprintListInfiniteQueryOptions } from "~/features/footprint/api";
import { FootprintTemplate } from "~/features/footprint/FootprintTemplate";

// MyProfileTemplate（layout）の上に全画面オーバーレイで重ねる
const FootprintPage = () => (
  <div className="fixed inset-0 z-40 bg-white">
    <FootprintTemplate />
  </div>
);

export const Route = createFileRoute("/_authenticated/my-page/footprint")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureInfiniteQueryData(footprintListInfiniteQueryOptions),
  component: FootprintPage,
});
